import { connectCustom } from "@client/lib/misc";
import { type AppState, Status } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import PageContainer, { type ActionProps, type LoadPage, type MapProps } from "./component";

type Props = WithChildren & {
  loadPage: LoadPage;
};

const mapStateToProps = (state: AppState, props: Props): MapProps => ({
  hideError: !state.isEditMode,
  homePageId: state.pages.homePageId,
  isLoading: state.status === Status.Loading,
  children: props.children
});

const mapDispatchToProps = (dispatch, props: Props): ActionProps => ({
  loadPage: props.loadPage
});

export default connectCustom(mapStateToProps, mapDispatchToProps)(PageContainer);
